module.exports = __webpack_public_path__ + "img/hourglass-empty.efd4a2f7.svg";